import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import { HairRemovalService } from 'src/app/_service/hair-removal.service';

declare var $: any;

@Component({
  selector: 'app-hair-removal-model',
  templateUrl: './hair-removal-model.component.html',
  styleUrls: ['./hair-removal-model.component.css']
})
export class HairRemovalModelComponent implements OnInit {

  placements = ['left'];
  popoverTitle = 'Are you sure?';
  popoverMessage = 'Are you really <b>sure</b> you want to do this?';
  confirmText = 'Yes <i class="fas fa-check"></i>';
  cancelText = 'No <i class="fas fa-times"></i>';
  confirmClicked = false;
  cancelClicked = false; fileDeleting: boolean = false;
  fileDeletingLoader: boolean = false;

  dialogData: any; hairRemovalForm: FormGroup; loading: boolean = false; submitted: boolean = false; dataLoaded: boolean = false;
  bds = []; bds_copy = []; myrole: string = ''; s3url = ''; disableSelect: any = []; invalidName: boolean = false;hairRemovalChk: boolean = false; doc_type: string = ''; uploading: boolean = false; allUploads = [];doctors = []; doctors_copy = [];

  constructor(public dialogRef: MatDialogRef<HairRemovalModelComponent>, @Inject(MAT_DIALOG_DATA) public data: MatDialog, private dialog: MatDialog, private router: Router, private sharedapi: SharedService, private leadapi: LeadsService, private formBuilder: FormBuilder, private hairremovalapi: HairRemovalService) {
    this.dialogData = data;
    let contactPattern = "[[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*]*";
    this.hairRemovalForm = this.formBuilder.group({
      'patient_name': [null, Validators.required],
      'mobile': [null, Validators.compose([Validators.required, Validators.pattern(contactPattern)])],
      'patient_age': [null, Validators.required],
      'gender': [null, Validators.required],
      'user_id': [null, Validators.required],
      'doctor_id': [null, Validators.required],
      'body_part': [null, Validators.required],
      'session': [null, Validators.required],
      'booking_date': [null, Validators.required],
      'time_slots': [null, Validators.required],
      'address': [null, Validators.required],
      'remarks': [null],
      'receivedAmtResources': this.formBuilder.array([]),
      'allSessionDetails': this.formBuilder.array([]),
    });
  }

  ngOnInit(): void {
    this.sharedapi.getRole().subscribe((item: string) => { this.myrole = item; });
    this.myrole = localStorage.getItem('role');
    this.s3url = localStorage.getItem('s3url');
    this.getbds();
    this.getDoctor();
    this.getHairRemovalLeadDetail();
    this.getHairRemovalBookingDetail();
    this.addMoreReceivedAmount();
    this.addMoreSession();
  }

  get f() { return this.hairRemovalForm.controls; }

  setSearchValue(type) {
    if (type == 'lead_owner') {
      $("#ownerSearch").val('');
      $("#ownerSearch").focus();
      this.bds = this.bds_copy;
    } else if (type == 'doctor') {
      $("#doctorSearch").val('');
      $("#doctorSearch").focus();
      this.doctors = this.doctors_copy;
    }
  }
  searchOnSelect(searchtText: string, type) {
    if (type == 'lead_owner') {
      this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
    } else if (type == 'doctor') {
      this.doctors = this.sharedapi.searchData(searchtText, this.doctors_copy, "name");
    }
  }

  async getHairRemovalLeadDetail() {
    this.dataLoaded = false;
    await this.hairremovalapi.getHairRemovalLeadDetail(this.dialogData.lead_id).subscribe((data: any) => {
      this.dataLoaded = true;
      if (data.status) {
        this.hairRemovalForm.controls['patient_name'].setValue(data.data.lead_name);
        this.hairRemovalForm.controls['mobile'].setValue(data.data.mobile);
        this.hairRemovalForm.controls['user_id'].setValue(data.data.user_id);
        this.hairRemovalForm.controls['patient_age'].setValue(data.data.patient_age);
        this.hairRemovalForm.controls['gender'].setValue(data.data.gender);
      } else {
        this.sharedapi.checkError(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getHairRemovalBookingDetail() {
    this.dataLoaded = false;
    await this.hairremovalapi.getHairRemovalBookingDetail(this.dialogData.lead_id).subscribe((data: any) => {
      this.dataLoaded = true;
      if (data.status) {
        if (data.hairRemovalBook) {
          this.hairRemovalForm.controls['doctor_id'].setValue(data.hairRemovalBook.doctor_id);
          this.hairRemovalForm.controls['body_part'].setValue(data.hairRemovalBook.body_part);
          this.hairRemovalForm.controls['session'].setValue(data.hairRemovalBook.session);
          this.hairRemovalForm.controls['booking_date'].setValue(data.hairRemovalBook.booking_date);
          this.hairRemovalForm.controls['time_slots'].setValue(data.hairRemovalBook.time_slots);
          this.hairRemovalForm.controls['address'].setValue(data.hairRemovalBook.address);
          this.hairRemovalForm.controls['remarks'].setValue(data.hairRemovalBook.remarks);
        }
        if (data.hairRemovalPayment) {
          let controlArray = this.hairRemovalForm.get('receivedAmtResources') as FormArray;
          controlArray.clear();
          data.hairRemovalPayment.forEach((element, index) => {
            controlArray.push(this.formBuilder.group({
              payment_mode: element.payment_mode,
              partial_amount: element.received_amount,
              hairRemovalPaymentId: element.id
            }));
          });
        }
        if (data.hairRemovalSession) {
          let controlArray = this.hairRemovalForm.get('allSessionDetails') as FormArray;
          controlArray.clear();
          data.hairRemovalSession.forEach((e, index) => {
            controlArray.push(this.formBuilder.group({
              sessionDetailId: e.id,
              session_name: e.session_name,
              session_date: e.session_date ,
              session_status: e.status
            }));
          });
        }
        if (data.hairRemovalBook.id != null && data.hairRemovalBook.id != "null" && data.hairRemovalBook.id != "") {
          this.hairRemovalChk = true;
        }
        if (data.uploads) {
          this.allUploads = data.uploads;
        }

      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async submitForm() {
    this.submitted = true;
    this.loading = true;

    //  validation if body_part seclect combo 
    if (this.hairRemovalForm.controls['body_part'].value == 13) {
      this.hairRemovalForm.controls['remarks'].setValidators(Validators.required);
      this.hairRemovalForm.controls['remarks'].updateValueAndValidity();
    }

    if (this.hairRemovalForm.invalid) {
      this.loading = false;
      return;
    }
    // validation for payment detail array
    let paymentDetailsArrayLength = this.hairRemovalForm.value.receivedAmtResources.length;
    if (paymentDetailsArrayLength < 1) {
      this.sharedapi.presentToast("Please Select Payment Details First");
      this.loading = false;
      return;
    }
    // end
    await this.hairremovalapi.addHairRemovalDetail(this.dialogData.lead_id, this.hairRemovalForm.value).subscribe((data: any) => {
      this.submitted = false;
      this.loading = false;
      if (data.status) {
        this.sharedapi.presentToast(data.msg);
        this.getHairRemovalBookingDetail();
      } else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  CloseModal(): void {
    this.dialogRef.close();
  }

  async getbds() {
    this.leadapi.getbds().subscribe((data: any) => {
      if (data.status) {
        this.bds = data.data;
        this.bds_copy = this.bds;
      } else {
        this.bds = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  receivedAmtResources(): FormArray {
    return this.hairRemovalForm.get("receivedAmtResources") as FormArray
  }

  addMoreReceivedAmount() {
    this.receivedAmtResources().push(this.newQuantity());
    let getIndex = this.hairRemovalForm.controls["receivedAmtResources"].value.length - 1;
    this.disableSelect[getIndex] = true;
  }

  newQuantity(): FormGroup {
    return this.formBuilder.group({
      hairRemovalPaymentId: '',
      payment_mode: [null, Validators.required],
      partial_amount: [null, Validators.required],
    })
  }

  removeQuantity(i: number, hairRemovalPaymentId) {
    if (hairRemovalPaymentId) {
      this.hairremovalapi.receivedAmountDeleted(hairRemovalPaymentId).subscribe((data: any) => {
        if (data.status) {
          this.getHairRemovalBookingDetail();
        }
      }, error => {
        this.sharedapi.checkError(error);
      });
    }
    else {
      this.receivedAmtResources().removeAt(i);
    }
  }

  async selectFile(event) {
    if (this.doc_type != "") {
      this.uploading = true;
      let file = event.target.files.item(0);
      const formData = new FormData();
      formData.append('upload_type', this.doc_type)
      formData.append('file', file);
      await this.hairremovalapi.uploadHairRemovalFile(this.dialogData.lead_id, formData)
        .subscribe((data: any) => {
          this.uploading = false;
          if (data.status) {
            this.sharedapi.presentToast('File uploaded Successful');
            this.getHairRemovalBookingDetail();
          } else {
            this.sharedapi.presentToast(data.msg);
          }
        }, error => {
          this.uploading = false;
          this.sharedapi.checkError(error);
        });
    } else {
      this.sharedapi.presentToast('Please select Document Type');
    }
  }

  removeFile(fileId) {
    this.fileDeleting = true;
    this.hairremovalapi.deleteHairRemovalFile(fileId).subscribe((data: any) => {
      this.fileDeleting = false;
      if (data.status) {
        this.getHairRemovalBookingDetail();
      } else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }


  async getDoctor() {
    await this.leadapi.getdoctors().subscribe((data: any) => {
      if (data.status) {
        this.doctors = data.data;
        this.doctors_copy = this.doctors;
      } else {
        this.doctors = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

 

  allSessionDetails(): FormArray {
    return this.hairRemovalForm.get("allSessionDetails") as FormArray
  }
  addMoreSession() {
    this.allSessionDetails().push(this.newSession());
    let getIndex = this.hairRemovalForm.controls["allSessionDetails"].value.length - 1;
    this.disableSelect[getIndex] = true;
  }
  newSession(): FormGroup {
    return this.formBuilder.group({
      sessionDetailId: '',
      session_name: [null, Validators.required],
      session_date: [null, Validators.required],
      session_status: [null, Validators.required],
    })
  }

  removeSession(i: number, sessionDetailId) {
    if (sessionDetailId) {
      this.hairremovalapi.selectedSessionDeleted(sessionDetailId).subscribe((data: any) => {
        if (data.status) {
          this.getHairRemovalBookingDetail();
        }
      }, error => {
        this.sharedapi.checkError(error);
      });
    }
    else {
      this.allSessionDetails().removeAt(i);
    }
  }
}
